export default __webpack_public_path__ + "f9c3a5668fbd8cbad33263b0fed16499.png";